<template>
    <div>
        <v-card-title>
            <h2 class="dialog-card__header">Name this project</h2>
        </v-card-title>
        <v-form @submit="submit($event)">
            <v-card-text>
                <v-text-field placeholder="Project name" v-model="name">
                </v-text-field>
            </v-card-text>
            <v-card-actions class="btn-container">
                <BackButton navigateTo="Projects"
                            :shouldClose="true">
                </BackButton>
                <v-btn :disabled="!name" class="custom-btn" color="secondary" @click="submit($event)">
                    Confirm
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>
</template>

<script>
    import BackButton from "../BackButton";
    import {store} from "../../store/store";
    import axios from "axios";

    export default {
        name: "NewProjectForm",
        components: {BackButton},
        data: () => ({
            domain_id: null,
            name: null,
            newProject: null,
        }),
        methods: {
            submit: function ($e) {
                $e.preventDefault();
                if (this.name) {
                    // TODO: refactor this into project.service!!
                    store.dispatch('getAccessToken').then(token => {
                            axios.post('/projects',
                                {
                                    domain_id: this.domain_id,
                                    name: this.name
                                },
                                {
                                    headers: {Authorization: "Bearer " + token}
                                }).then(resp => {
                                this.newProject = resp.data.project
                                this.$router.push({name: 'ProjectOverview', params: {projectId: this.newProject.id}})
                            })
                        }
                    ).catch(err => console.log(err))
                }
            },
        },
        mounted() {
            this.domain_id = this.$route.params.domain_id;
        }
    }
</script>

<style scoped>

</style>
